import React, { useState } from 'react';
import * as S from './styles';

import CardSolicitacaoDesktop from './desktop';
import CardSolicitacaoMobile from './mobile';
import Modal from '../../modal/modalGeneric';
import EditProdutor from '../../../pages/produtores/edit';
import EditFazenda from '../../../pages/produtores/editLocal';
import ModalVincularFazenda from './ModalVincularFazenda';
import { handleSavedRecipe, isDisabledStatus, isCadastroIncompleto, isProdutorIncompleto, isFazendaIncompleta, isFazendaAusente } from './helpers';

const CardSolicitacoes = ({ items = [], maxWidth, width, onDataChanged }) => {
  const [validandoItem, setValidandoItem] = useState(null);
  const [showModalProdutor, setShowModalProdutor] = useState(false);
  const [showModalFazenda, setShowModalFazenda] = useState(false);
  const [showModalVincularFazenda, setShowModalVincularFazenda] = useState(false);

  const handleClick = (item) => {
    if (isCadastroIncompleto(item)) {
      setValidandoItem(item);
      if (isProdutorIncompleto(item?.agro_producers)) {
        setShowModalProdutor(true);
      } else {
        setShowModalFazenda(true);
      }
      return;
    }
    if (isFazendaAusente(item)) {
      setValidandoItem(item);
      setShowModalVincularFazenda(true);
      return;
    }
    handleSavedRecipe(item);
  };

  return (
    <S.ContainerTable $maxWidth={maxWidth}>
      {items.map((item, idx) => {
        const disabled = isDisabledStatus(item?.status);
        const itemKey = item?.id || idx;

        return (
          <S.ContainerTableRow
            key={itemKey}
            $width={width}
            $lastChild={idx === items.length - 1}
            $disabled={disabled}
            $clickable={!disabled}
            onClick={() => !disabled && handleClick(item)}
          >
            <S.DesktopCard>
              <CardSolicitacaoDesktop item={item} disabled={disabled} />
            </S.DesktopCard>

            <S.MobileCard>
              <CardSolicitacaoMobile item={item} disabled={disabled} itemKey={itemKey} />
            </S.MobileCard>
          </S.ContainerTableRow>
        );
      })}

      {showModalProdutor && validandoItem?.agro_producers?.id && (
        <Modal
          size='lg'
          show={showModalProdutor}
          onHide={() => setShowModalProdutor(false)}
        >
          <EditProdutor
            idProdutor={validandoItem.agro_producers.id}
            isModal={true}
            lockFilledFields={true}
            update={() => {
              setShowModalProdutor(false);
              onDataChanged?.();
              if (isFazendaIncompleta(validandoItem?.agro_farms)) {
                setShowModalFazenda(true);
              }
            }}
            openModal={(e) => setShowModalProdutor(e)}
          />
        </Modal>
      )}

      {showModalFazenda && validandoItem?.agro_farms?.id && validandoItem?.agro_producers?.id && (
        <Modal
          size='lg'
          show={showModalFazenda}
          onHide={() => setShowModalFazenda(false)}
        >
          <EditFazenda
            idFazenda={validandoItem.agro_farms.id}
            idProdutor={validandoItem.agro_producers.id}
            isModal={true}
            openModal={(e) => {
              setShowModalFazenda(e);
              if (!e) onDataChanged?.();
            }}
          />
        </Modal>
      )}

      {showModalVincularFazenda && validandoItem?.id && validandoItem?.agro_producers?.id && (
        <Modal
          size='lg'
          show={showModalVincularFazenda}
          onHide={() => setShowModalVincularFazenda(false)}
        >
          <ModalVincularFazenda
            orderId={validandoItem.id}
            produtorId={validandoItem.agro_producers.id}
            onClose={() => setShowModalVincularFazenda(false)}
            onVinculado={() => {
              setShowModalVincularFazenda(false);
              onDataChanged?.();
            }}
          />
        </Modal>
      )}
    </S.ContainerTable>
  );
};

export default CardSolicitacoes;
